module.exports = __webpack_public_path__ + "cb8876dadba68d148217dc238e429671.svg";